import React, { useState, useEffect } from 'react';

interface Props {
  id?: string;
  className?: string;
  disabled?: boolean;
  label: string;
  options: any;
  placeholder?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
}

export const CustomFloatingSelect: React.FC<Props> = ({
  id,
  className,
  disabled,
  label,
  options,
  placeholder,
  defaultValue,
  onChange,
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue ?? '');

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  useEffect(() => {
    if (defaultValue) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue]);

  return (
    <section className="relative w-full">
      <select
        id={id}
        className={`custom-scrollbar gbmask peer block appearance-none rounded-lg border border-foggyGray bg-transparent p-4 text-base text-black ${className}`}
        value={selectedValue}
        onChange={handleSelectChange}
        disabled={disabled}
      >
        <option value="" disabled hidden className="py-4">
          <p className="text-gray-500">{placeholder}</p>
        </option>
        {options}
      </select>
      {selectedValue ? (
        <label
          htmlFor={id}
          className={`absolute start-1 top-1 ml-1 origin-[0] -translate-y-4 scale-75 bg-white px-2 text-base duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4`}
        >
          {label}
        </label>
      ) : null}
    </section>
  );
};
